/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Message de contact envoyé au commercial.
 */
export const contactMessageSchema = z.object({
      "subject": z.string().describe("Objet du mail"),
  "content": z.string().describe("Contenu du mail")
      }).describe("Message de contact envoyé au commercial.")